<template>
    <div class="ig-app"
        @touchmove.prevent>
        <keep-alive
            :max="5"
            :include="['ig-index', 'ig-notice', 'ig-moment', 'ig-moment-group', 'ig-moment-group-detail', 'ig-moment-topic', 'ig-moment-topic-detail', 'ig-moment-collection', 'ig-moment-collection-detail', 'ig-moment-user-ranking', 'ig-doujin', 'ig-playbook', 'ig-label', 'ig-label-detail', 'ig-video', 'ig-me', 'ig-user', 'ig-home', 'ig-favorites', 'ig-browse', 'ig-message', 'ig-search']">
            <router-view></router-view>
        </keep-alive>
        <sui-swiper-image
            key-name="url"
            :show="showSwiperImage"
            :images="swiperImages"
            :index="swiperImageIndex"
            @click="swiperImageClick"></sui-swiper-image>
        <igc-face-img :include="['index','moment']"></igc-face-img>
    </div>
</template>

<script>
import { getUrlParam, loadScript } from 'scripts/utils/index'
import { get, jsonp, request, requestJsonp } from 'scripts/request'
import { reportPerformanceData } from 'scripts/requests/report'

import mCore from 'scripts/mixins/core'
import IgcFaceImg from '../../components/face-img/face-img.vue'

const tencentMap = new qq.maps.Geolocation() // 腾讯地图

export default {
    name: 'ig-app',

    mixins: [mCore],

    components:{
        IgcFaceImg
    },

    data() {
        const { config } = window
        return {
            navigators: config.navigators,
            timestamp: 0
        }
    },

    computed: {
        position() {
            return this.$store.state.global.position
        },

        userInfo() {
            return this.$store.state.global.userInfo
        },

        swiperImages() {
            return this.$store.state.global.swiperImages
        },

        showSwiperImage() {
            return this.$store.state.global.showSwiperImage
        },

        swiperImageIndex() {
            return this.$store.state.global.swiperImageIndex
        },

        locationOpen() {
           return this.$store.getters['global/locationOpen']
        }
    },

    created() {

        /* #region 是否首次访问微社区 */
        if (typeof localStorage.igVisited == 'undefined') {
            this.$store.commit('global/updateIsFirst', true)
            localStorage.topicBackHome20191025 = 1  //实验期间的新进用户
            localStorage.igVisited = 1
        }
        /* #endregion */

        // #region 获取标签信息列表
        loadScript(`https://gicp.qq.com/wmp/data/js/v3/WMP_TAGLIST_GW_${ this.$store.state.global.config.p0 }.js`).then(() => {
            const { msg = [] } = window.tagObj
            let labels = {}
            msg.forEach((item) => {
                labels[item.iTag] = item
            })
            this.$store.commit('global/updateLabels', labels)
        })
        // #endregion

        // #region 知识点信息
        loadScript(`https://tiem-cdn.qq.com/sy/${ this.mGame }/ingame/scripts/${ sessionStorage.igEnv == 'development' ? 'test_' : '' }knowledge.js`).then(() => {
            this.$store.commit('global/updateKnowledge', window.knowledge)
        }).catch(error => {
            // 防止 Sentry 自动上报错误
        })
        // #endregion

        let that = this;

        // #region 评论配色
        document.querySelector('head').insertAdjacentHTML('beforeend', `<style>
            .comment-main .comment--highlight {
                font-size: 12px;
                color: ${ this.mColor(4) };
            }
            .comment-main .comment-main--header,
            .comment-main .comment-main--header-prompt {
                font-size: 12px;
                color: ${ this.mColor(3) };
            }
            .comment-main .comment-main--title {
                font-size: 15px;
                color: ${ this.mColor(1) };
            }
            .comment-main .comment-item--avatar {
                width: 28px;
                height: 28px;
            }
            .comment-main .comment-item--name {
                font-size: 12px;
                color: ${ this.mColor(2) };
            }
            .comment-main .comment-item--time {
                font-size: 9px;
                color: ${ this.mColor(3) };
            }
            .comment-main .comment-item--content {
                font-size: 13px;
                color: ${ this.mColor(1) };
            }
            .comment-main .comment-item--like,
            .comment-main .comment-main--tips {
                font-size: 10px;
                color: ${ this.mColor(3) };
            }
            .comment-main .comment-item .comment-item {
                background-color: ${ this.mColor(8.2) };
            }
            .ig-app .comment-add-bar {
                background: ${ this.mBackground(8.1, 'top', 9) };
            }
            .ig-app .comment-add-bar--input {
                color: ${ this.mColor(2.1) };
                background-color: ${ this.mColor(10) };
            }
        </style>`)
        // #endregion

        if (sessionStorage.tokenParams) {
            this.getUserInfo()
            //地理位置配置开关 true-打开  false-关闭
            if (this.locationOpen) {
                this.getPosition()
            }
        }

        /* #region 评论组件全局绑定该事件头像点击跳转个人中心 */
        this.$comment._vm.$on("avatarClick",cm=>{
            this.$router.push({
                name: 'guest-info',
                params: {
                    id: cm.commid || cm.repid
                }
            })
            this.mEventTrackingToMosso('comment_avatar', 'click', '评论头像点击')
        })
        // #endregion

        if (process.env.NODE_ENV == 'production' && sessionStorage.igEnv != 'development') {
            window.addEventListener('load', (event) => {
                /* #region aegis性能监控自定义上报 */
                if (performance && performance.timing) {
                    const { timing } = performance
                    window.aegisReport.reportTime('domInteractive', timing.domInteractive - timing.navigationStart)
                    window.aegisReport.reportTime('domContentLoaded', timing.domContentLoadedEventStart - timing.navigationStart)
                    window.aegisReport.reportTime('loaded', timing.loadEventStart - timing.navigationStart)
                    reportPerformanceData({
                        speedparams: `flag1=22259&flag2=1&flag3=1&8=${ timing.domInteractive - timing.navigationStart }&9=${ timing.domContentLoadedEventStart - timing.navigationStart }&10=${ this.timestamp - timing.navigationStart }&12=${ timing.loadEventStart - timing.navigationStart }&${ localStorage.igHasCache ? 14 : 13 }=${ timing.loadEventStart - timing.navigationStart }&15=${ timing.domContentLoadedEventStart - timing.navigationStart }`
                    })
                    localStorage.igHasCache = 1
                }
                /* #endregion */
            })
        }

        window.addEventListener('popstate', () => {
            if (this.$store.state.global.showSwiperImage) {
                this.$store.commit('global/updateShowSwiperImage', false)
            }
        })

        if (!/(iPhone|iPad|iPod)/i.test(navigator.userAgent)) {   //非ios下的异形屏才需要处理
            // #region 异形屏适配
            if(this.judgeScreen() == 'portrait'){
                document.querySelector('head').insertAdjacentHTML('beforeend', `<style>
                    .igc-frame>.ig--header {
                        min-height: 2.438rem;
                        background-position: bottom;
                        background-size: 100%;
                    }
                    .comment-main,.comment-add-bar {
                        padding-bottom: 1.313rem;
                    }
                </style>`)
            }
            if(this.judgeScreen() == 'landscape'){
                document.querySelector('head').insertAdjacentHTML('beforeend', `<style>
                    .igc-frame>.ig--container .ig--navbar,.comment-main,.comment-add-bar {
                        padding-left: 2.75rem;
                    }
                </style>`)
            }
        }
        // #endregion
    },

    mounted() {
        this.timestamp = Date.now()
    },

    methods: {

        /**
         * 获取个人信息并保存
         */
        getUserInfo() {
            jsonp({
                url: '/comment/user_info.php', // 仅支持 MSDK 登录态
                data: {
                    openids: this.userInfo.openid
                }
            }).then(result => {
                if(!result.avatar){
                    result.avatar = 'https://tiem-cdn.qq.com/slugteam/public/img/user.png'
                }
                result.avatar = this.mHttps(result.avatar)
                this.$store.commit('global/updateUserInfo', result)
                if(result.openid){  //兼容游戏客户端没有传递openid导致的主态身份问题
                    if(sessionStorage.tokenParams.indexOf('openid=') === -1){
                        sessionStorage.tokenParams += '&openid=' + result.openid
                    }else if(getUrlParam('openid',sessionStorage.tokenParams) != result.openid){
                        sessionStorage.tokenParams = sessionStorage.tokenParams.replace(/(\\?|&)openid=([^&#]*)/,'&openid=' + result.openid)
                        this.$comment._vm.userInfo.openid = result.openid
                        this.$comment.userInfo.openid = result.openid
                    }
                }
                let obj = Object.assign({},result)
                obj.avatar = encodeURIComponent(obj.avatar)
                /* #region 保存个人信息 */
                jsonp({
                    url: '/usercenter/save_user_profile.php',
                    data: obj
                })
                /* #endregion */

            }).catch((e)=>{
                console.log(e)
            })
        },

        /**
         * 获取地理位置并监听
         */
        getPosition() {

            /* #region IP 定位 */
            tencentMap.getIpLocation(positon => {
                if (this.position.lat) {
                    delete positon.lat
                }
                if (this.position.lng) {
                    delete positon.lng
                }
                this.$store.commit('global/updatePosition', position)
            })
            /* #endregion */

            /* #region 精确定位 */
            tencentMap.getLocation(positon => {
                this.$store.commit('global/updatePosition', position)
            }, error => {
                // 暂不处理
            }, {
                failTipFlag: true
            })
            /* #endregion */

            /* #region 获取 & 监听地理位置 */
            tencentMap.watchPosition(position => {
                this.$store.commit('global/updatePosition', position)
            })
            /* #endregion */

        },

        /* #region 全面屏判断 */
        judgeScreen() {
            let result = false;
            const rate = window.screen.height / window.screen.width
            // window.screen.height为屏幕高度
            //  window.screen.availHeight 为浏览器 可用高度
            if(rate > 2){
                result = 'portrait'
            }
            if(rate < 1/2){
                result = 'landscape'
            }
            return result
        },
        /* #endregion */

        swiperImageClick() {
            history.back()
        },
    }
}
</script>

<style lang="postcss">
.ig-app {
    height: 100%;
    .comment-main {
        @media (max-aspect-ratio: 1/2) {
            padding-bottom: var(--safe-area-inset-bottom);
        }
        @media (min-aspect-ratio: 2/1) {
            padding-right: var(--safe-area-inset-right);
            padding-bottom: var(--safe-area-inset-bottom);
            padding-left: var(--safe-area-inset-left);
        }
    }
    .comment-add-bar {
        z-index: 98;
        display: flex;
        padding: 12px 30px;
        @media (max-aspect-ratio: 1/2) {
            padding-bottom: var(--safe-area-inset-bottom);
        }
        @media (min-aspect-ratio: 2/1) {
            padding-right: var(--safe-area-inset-right);
            padding-bottom: var(--safe-area-inset-bottom);
            padding-left: var(--safe-area-inset-left);
        }
        .comment-add-bar--input {
            height: 64px;
            margin: 0;
            padding: 0 20px;
            border: none;
            font-size: 24px;
        }
        .comment-add-bar--input:before {
            margin-left: 0;
        }
        .ig--button {
            position: relative;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            width: 60px;
            margin-left: 24px;
            .ig--icon {
                width: 42px;
                height: 42px;
            }
            .ig--comment-num,
            .ig--like-num {
                position: absolute;
                bottom: 60%;
                left: 75%;
                display: flex;
                justify-content: center;
                align-items: center;
                height: 20px;
                padding: 0 6px;
                border-radius: 10px;
                font-size: 18px;
            }
            .ig--comment-num {
                color: #fff;
                background: #eb2424;
            }
        }
    }
    .comment-input,
    .np-comment-report-pop {
        z-index: 99;
        box-sizing: border-box;
        @media (max-aspect-ratio: 100/196) {
            padding-top: var(--safe-area-inset-top);
        }
        @media (min-aspect-ratio: 2/1) {
            padding-right: var(--safe-area-inset-right);
            padding-left: var(--safe-area-inset-left);
        }
    }
}
</style>
